export default __webpack_public_path__ + "static/media/castalia.2f03f9be.png";